import {loadSVGIcons} from '../utilities/index.js';

document.addEventListener('DOMContentLoaded', function() {
    /* If user deep links to solutions or industries section track preferred industry */

    if ('localStorage' in window && window['localStorage'] !== null) {
        const locationparts = location.pathname.replace(/\/+$/, '').split('/');
        const isSolutionsChild = (locationparts[locationparts.length - 3] == 'industry-solutions');
        let lastSegment = locationparts[locationparts.length - 2];

        if (isSolutionsChild) {
            localStorage.setItem('industryType', lastSegment);
        }

        const isIndustriesChild = (locationparts[locationparts.length - 2] == 'industry-solutions');
        lastSegment = locationparts[locationparts.length - 1];

        if (isIndustriesChild) {
            localStorage.setItem('industryType', lastSegment);
        }
    }

    /* Solutions / Products Archive Page Code */

    let industryType, postType = null;
    let productOrSolutionCPT = false;

    if (document.querySelector('.page-template-archive-solutions')) {
        postType = 'solutions';
        productOrSolutionCPT = true;
    }
    if (document.querySelector('.page-template-archive-products')) {
        postType = 'products';
        productOrSolutionCPT = true;
    }
    if (document.querySelector('.customer-success-grid')) {
        postType = 'customer_success';
    }

    const industrycontainer = document.querySelector('.grid-filter-tabs');
    let childpagecontainer;

    if (postType) {
        /* retreival of all solutions post industry custom tags */
        childpagecontainer = document.querySelector('.filtered-grid-container');

        let urlpath;
        if (postType == 'solutions') {
            urlpath = wpObj.solutionsAPI;
        } else {
            urlpath = wpObj[postType];
        }

        fetch(urlpath)
            .then(response => response.json())
            .then(data => {
                document.querySelector('.load-spinner')?.classList.add('load-spinner-hide');
                
                data.forEach(item => {
                    /* check if has an industry custom tag else its a parent element */
                    let filteredindustryslugList = '';

                    if (item.terms.length > 0) {
                        filteredindustryslugList = item.terms
                            .map(term => term.slug)
                            .join(' ');

                        let anchorcontent = '';
                        let ft_image;
                        
                        if (productOrSolutionCPT) {
                            if ((item.acf && item.acf.post_icon_image)) {
                                ft_image = item.acf.post_icon_image;
                                anchorcontent += `<img src='${ft_image}' height=42 width=42 class='post_icon_image'/>`;
                            }
                            anchorcontent += `<h3>${item.title}</h3>`;
                            anchorcontent += (item.excerpt.length) ? item.excerpt : '';
                            
                        } else {
                            /* Customer success landing page */
                            if (item.media) {
                                ft_image = item.media['card-image'];
                                anchorcontent += `<span class=story-img style='background-image:url(${ft_image})'><img src='${ft_image}' alt=''></span>`;
                            }
                            
                            /* Radio Button choice */
                            let customer_name;

                            if (!item.acf.customer_name_options || (item.acf.customer_name_options && item.acf.customer_name_options['value'] == 'customername')) {
                                customer_name = item.acf.customer_name.split(' ')[0] + '\'s';
                            } else if (item.acf.customer_name_options && item.acf.customer_name_options['value'] == 'noname') {
                                customer_name = '';
                            } else {
                                customer_name = item.acf.customer_name_options['label'] + '\'s';
                            }

                            anchorcontent += '<span class=story-content><span class="text-wrapper">';
                            anchorcontent += (item.excerpt.length) ? item.excerpt : '';
                            anchorcontent += `</span><span class="read-more-footer"><hr/><span class=read-more>Read ${customer_name} Story</span>`;
                            anchorcontent += '</span></span>';
                        }
                        
                        const a = document.createElement('a');
                        a.innerHTML = anchorcontent;
                        a.setAttribute('href', item.permalink);
                        a.classList.add(...filteredindustryslugList.split(' ').filter(c => c !== ''));

                        if (postType == 'products') {
                            document.querySelector('#allProducts').appendChild(a);
                        } else {
                            document.querySelector('.filtered-grid').appendChild(a);
                        }
                    }
                });

                /* Get all categories from product categories elements and clone in products to the assigned categories */
                if (postType == 'products') {
                    document.querySelectorAll('.product-categories').forEach(category => {
                        const productCategories = category.dataset.categories;
                        
                        /* Find all products and copy them into product elements */
                        document.querySelectorAll(`#allProducts .${productCategories}`).forEach(product => {
                            const productClone = product.cloneNode(true);
                            document.querySelector(`.filtered-grid [data-categories=${productCategories}] .d-flex`).appendChild(productClone);
                        });
                    });
                }
                
                /* Select initial tab navigation button */
                if (productOrSolutionCPT) {
                    if ('localStorage' in window && window['localStorage'] !== null) {
                        industryType = localStorage.getItem('industryType');
                        industryType = (industryType !== null) ? industryType : 'skilled-nursing';
                        applyIndustryToSolutions(industryType, true);

                        loadSVGIcons();
                    }
                } else {
                    /* customer success post type */
                    industryType = 'improve-quality-care';
                    applyIndustryToSolutions(industryType, true);
                }
            })
            .catch(error => console.error('Error fetching data:', error));

    } else {
        if ('localStorage' in window && window['localStorage'] !== null) {
            industryType = localStorage.getItem('industryType');
            industryType = (industryType !== null) ? industryType : 'skilled-nursing';

            applyIndustryToSolutions(industryType, true);
        }
    }

    if (industrycontainer) {
        industrycontainer.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                industrycontainer.querySelectorAll('a').forEach(a => a.classList.remove('active'));
                this.classList.add('active');

                document.getElementById("overlay").style.display = 'none';
                const industryType = this.getAttribute('segment');
                showProductCategoryTitles(industryType);
                applyIndustryToSolutions(industryType);
            });
        });
    }

    function applyIndustryToSolutions(industryType, init) {
        if (postType != 'customer_success') localStorage.setItem('industryType', industryType);
        document.body.setAttribute('data-preferred-industry', industryType);
        
        if (childpagecontainer) {
            childpagecontainer.style.display = 'none';
            
            const allLinks = childpagecontainer.querySelectorAll('a');
            allLinks.forEach(link => link.style.display = 'none');
            
            const industryLinks = childpagecontainer.querySelectorAll(`.${industryType}`);
            industryLinks.forEach(link => link.style.display = '');
            
            childpagecontainer.style.display = '';
            
            childpagecontainer.querySelectorAll('div').forEach(div => {
                div.setAttribute('data-industryType', industryType);
            });
        }
        
        if (init && industrycontainer) {
            const activeTab = industrycontainer.querySelector(`.${industryType}`);
            if (activeTab) activeTab.classList.add('active');
            showProductCategoryTitles(industryType);
            document.getElementById("overlay").style.display = 'none';
        }
    }

    /* Only display titles if there are any associated products with that industry */
    function showProductCategoryTitles(industryType) {
        const productCategories = document.querySelectorAll('.product-categories');
        productCategories.forEach(category => {
            category.classList.add('hidden');
            if (category.querySelector(`.product-container .${industryType}`)) {
                category.classList.remove('hidden');
            }
        });
    }

    /* Accordion Add active class to opened header */
    document.querySelectorAll('.collapse').forEach(collapse => {
        collapse.addEventListener('shown.bs.collapse', function() {
            this.previousElementSibling.classList.add('active-acc');
        });

        collapse.addEventListener('hidden.bs.collapse', function() {
            this.previousElementSibling.classList.remove('active-acc');
        });
    });
});





